import 'styled-components/macro';
import 'twin.macro';
import { RouteChildrenProps, useHistory, useRouteMatch } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { TrackReviewComplete } from '../../atoms/track-review-complete/TrackReviewComplete';
import { TrackReviewFeedback } from './TrackReviewFeedback';
import { TrackReviewRating } from './TrackReviewRating';

export interface TrackReviewProps {
  trackID: string;
  teamSlug: string;
}

export const TrackReview = ({ trackID, teamSlug }: TrackReviewProps) => {
  const { path, url } = useRouteMatch();
  const history = useHistory();

  const toFeedbackPage = (id: string) => history.push(`${url}/review/${id}`);
  const toThankYouPage = () => history.push(`${url}/thanks`);

  return (
    <Switch>
      <Route path={`${path}/thanks`}>
        <TrackReviewComplete />
      </Route>

      <Route path={`${path}/review/:reviewID`}>
        {({ match }: RouteChildrenProps<{ reviewID: string }>) => (
          <TrackReviewFeedback reviewID={match!.params.reviewID} toThankYouPage={toThankYouPage} />
        )}
      </Route>

      <Route>
        <TrackReviewRating
          trackID={trackID}
          teamSlug={teamSlug}
          toFeedbackPage={toFeedbackPage}
          toThankYouPage={toThankYouPage}
        />
      </Route>
    </Switch>
  );
};
